var App = App || {};

App.Alerts = (function ($) {
    'use strict';

    function Close() {
        var alerts = $("#Alerts").find(".alert");
        alerts.each(function (index, alert) {
            $(alert).on("closed.bs.alert", function () {
                const guid = $(alert).attr("data-guid");
                const cookieName = `FirstCityCU_Alert_${guid}`;
                App.Cookies.setItem(cookieName, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            })
        });
    }

    return {
        Close: Close
    };

})(jQuery);